export const SUBMIT_SERIVCE_APPLICATION = gql`
    mutation submitServiceApplication($input: SubmitServiceApplicationInput!) {
        submitServiceApplication(input: $input) {
            status
            merchantId
            applicationId
        }
    }
`;
export const REQUEST_SERIVCE_APPLICATION_BUILD = gql`
    mutation requestServiceApplicationBuild($input: RequestServiceApplicationBuildInput!) {
        requestServiceApplicationBuild(input: $input) {
            status
            merchantId
            terminalId
            applicationId
            emailSent
        }
    }
`;

export const ACTIVATE_SERVICE = gql`
    mutation activateService($input: ActivateServiceInput!) {
        activateService(input: $input) {
            applicationId
            status
        }
    }
`;
